class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.anchor = this.querySelector("a");
    if (!this.anchor) return;

    this.isLoading = false; // Guard to prevent duplicate fetches

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Only trigger if intersecting and not already loading
        if (entry.isIntersecting && !this.isLoading) {
          this.loadNextPage();
        }
      });
    }, { rootMargin: '0px 0px 400px 0px' }); // Load 400px before reaching bottom

    this.observer.observe(this);
  }

  async loadNextPage() {
    this.isLoading = true;
    this.anchor.style.display = "flex";
    this.anchor.innerText = "Loading more products...";

    const url = this.anchor.getAttribute("href");
    if (!url) {
        this.isLoading = false;
        return;
    }

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, "text/html");

      const newGrid = html.querySelector("[data-product-grid]");
      const grid = document.querySelector("[data-product-grid]");

      if (newGrid && grid) {
        // Use a DocumentFragment for better performance and to avoid visual blinks
        const fragment = document.createDocumentFragment();
        Array.from(newGrid.children).forEach((child) => {
          // Check if it's a valid product block (ignore empty text nodes/ajax containers)
          if (child.nodeType === 1 && !child.classList.contains('ajax-container')) {
             fragment.appendChild(child.cloneNode(true));
          }
        });
        grid.appendChild(fragment);

        // Re-initialize theme animations if used
        if (window.AOS) window.AOS.refresh(); 
      } else {
        console.warn("InfiniteScroll: No [data-product-grid] found in fetched page.");
      }

      // Handle next infinite scroll replacement
      const newInfinite = html.querySelector("infinite-scroll");
      if (newInfinite && newInfinite.querySelector("a")) {
        this.replaceWith(newInfinite);
      } else {
        this.remove(); // End of collection reached
      }
    } catch (err) {
      console.error("InfiniteScroll error:", err);
      this.anchor.innerText = "Error loading. Please scroll up and try again.";
    } finally {
      this.isLoading = false;
    }
  }
}

customElements.define("infinite-scroll", InfiniteScroll);


// class InfiniteScroll extends HTMLElement {
//   constructor() {
//     super();
//     this.anchor = this.querySelector("a");
//     if (!this.anchor) return;

//     this.observer = new IntersectionObserver((entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           this.loadNextPage();
//         }
//       });
//     });

//     this.observer.observe(this);
//   }

//   async loadNextPage() {
//     this.observer.disconnect();

//     this.anchor.style.display = "flex";
//     this.anchor.innerText = "Loading...";

//     const url = this.anchor.getAttribute("href");
//     if (!url) return;

//     try {
//       const response = await fetch(url);
//       const text = await response.text();
//       const html = new DOMParser().parseFromString(text, "text/html");

//       // Grab the product grid from the next page
//       const newGrid = html.querySelector("[data-product-grid]");
//       const grid = document.querySelector("[data-product-grid]");

//       if (newGrid && grid) {
//         Array.from(newGrid.children).forEach((child) => {
//           grid.appendChild(child);
//         });
//       }

//       // Handle next infinite scroll
//       const newInfinite = html.querySelector("infinite-scroll");
//       if (newInfinite) {
//         this.replaceWith(newInfinite);
//       } else {
//         this.remove();
//       }
//     } catch (err) {
//       console.error("InfiniteScroll error:", err);
//     }

//     this.anchor.style.display = "none";
//     this.anchor.innerText = "";
//   }
// }

// customElements.define("infinite-scroll", InfiniteScroll);